import { Box } from "@mui/material";
import { NavBar } from "../navbar";
import { ContactUsSection } from "../contact";
import {
  VideosSection,
  GraphHeroSection,
  PaperAndPowerpointResources,
  AIPodcastsSection,
} from "./components";
import Hero from "../hero";

import { useEffect } from "react";

export default function Resources() {
  useEffect(() => {
    document.title = "Resources";
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      <Hero
        image="/resources.jpg"
        title="Resources"
        blurb="Browse videos, our graph database, research papers, and more to explore
        how AI and clinical expertise are shaping the future of hereditary
        cancer care."
      />
      <VideosSection />
      <GraphHeroSection />
      <AIPodcastsSection />
      <PaperAndPowerpointResources />
      <ContactUsSection />
    </Box>
  );
}
